export const flightDate = (date: string) => {
  const dateObj = new Date(date.split('T')[0].replaceAll('-', '/'))

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const day = dateObj.getDate()

  const month = months[dateObj.getMonth()]

  const year = dateObj.getFullYear()

  return month + ' ' + day + ', ' + year
}

export const flightTime = (date: string) =>
  date.split('T')[1].replace('Z', '') ?? '00:00'
